import * as React from 'react';
import * as classNames from 'classnames';

export default ({leftComponent, middleComponent, rightComponent, onKeyDown, onClick}: InlineInputProps) => {
   const middleComponentClasses = classNames('middle-component', {'left-border-radius': !leftComponent}, {'right-border-radius': !rightComponent});

   return (
      <div className="inline-input" onKeyDown={onKeyDown} onClick={onClick}>
         <div className="pseudo-input-background"/>
         {leftComponent && <div className="left-component left-border-radius">{leftComponent}</div>}
         <div className={middleComponentClasses}>{middleComponent}</div>
         {rightComponent && <div className="right-component right-border-radius">{rightComponent}</div>}
      </div>
   );
};

interface InlineInputProps {
   leftComponent?: JSX.Element;
   middleComponent: JSX.Element;
   rightComponent?: JSX.Element;
   onClick?(e: any): void;
   onKeyDown?(e: any): void;
}